import { localStorage } from '../storage'
import { localStorageKeys } from '@/common/storage-keys'

export enum AppTheme {
    Normal = 0,
    Fun = 1
}

export function getCurrentTheme (): AppTheme {
  const theme = localStorage.get(localStorageKeys.THEME, AppTheme.Normal) as AppTheme

  return theme
}

export function setTheme (theme: AppTheme) {
  const THEME_CLS = 'fun-theme'
  const action = theme === AppTheme.Fun ? 'add' : 'remove'

  localStorage.set(localStorageKeys.THEME, theme)
  document.documentElement.classList[action](THEME_CLS)
}

export function getThemeCls () {
  return getCurrentTheme() === AppTheme.Normal ? '' : 'fun'
}

export function initTheme () {
  const theme = getCurrentTheme()

  setTheme(theme)
}
